var locale = {
  placeholder: '날짜 선택'
};
export default locale;
//# sourceMappingURL=ko_KR.js.map
